import { removeBonusCardRequestedState } from "@services/bonusCard.service";
import { PreferredStoreService } from "@services/preferredStore.service";
import { SoftLoginService } from "@services/softLogin.service";

import { StorageKeys } from "./enums";
import { AlgoliaTrackingService } from "@services/algolia/tracking/algoliaTracking.service";

export function logoutCleanUp(): void {
    let { email } = SoftLoginService.getSoftLoginDetails();
    if (!email) {
        email = sessionStorage.getItem(StorageKeys.GuestEmail);
    }
    SoftLoginService.clearSoftLogin();
    PreferredStoreService.removePreferredStoreOfTheUser();
    AlgoliaTrackingService.logout();
    if (email) {
        removeBonusCardRequestedState(email);
    }
}
